import { chakra } from "@chakra-ui/react"

// Required-field asterisk: one of the rare red marks the design system allows (ADR 0001, Q14).
export default () => <chakra.span color="accent"> *</chakra.span>
